export enum MutationList {
    SET_USER = 'user/SET_USER',
    UNSET_USER = 'user/UNSET_USER',
    SET_RELATIVES = 'SET_RELATIVES',
    CHANGE_USER_NAME= 'CHANGE_USER_NAME',
    CHANGE_USER_SURNAME = 'CHANGE_USER_SURNAME',
    SAVE_APPOINTMENT_TO_USER = 'SAVE_APPOINTMENT_TO_USER',
    DELETE_APPOINTMENT_FROM_USER = 'SPLICE_APPOINTMENT_FROM_USER',
    SAVE_APPOINTMENT_TO_RELATIVE = 'SAVE_APPOINTMENT_TO_RELATIVE',
    DELETE_APPOINTMENT_FROM_RELATIVE = 'DELETE_APPOINTMENT_FROM_RELATIVE',
    SAVE_TOKEN = 'SAVE_TOKEN',
    SET_AUTHENTICATED_TO_TRUE = 'SET_AUTHENTICATED_TO_TRUE',
    SAVE_NEW_RELATIVE = 'SAVE_NEW_RELATIVE',
}

